import { switchMap } from 'rxjs';
import { fromFetch } from 'rxjs/fetch';
import { searchCommunitySitePlans } from 'constants/routes'

/**
 * Parses the fetch response into JSON.
 * Throws on non-2xx responses so the observable errors.
 *
 * NOTE:
 * - Consumers are responsible for handling errors (e.g. catchError, retry).
 */
const parseJsonResponse = (response) => {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  return response.json();
};


/**
 * Retrieves community site plans associated to a given community id.
 * @param {Object} payload - The payload containing the list of community ids.
 * @returns {Observable} - An observable that emits the community site plans information.
 */
function searchCommunitySitePlansInformation(payload) {
  return fromFetch(searchCommunitySitePlans, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    body: JSON.stringify(payload),
  }).pipe(
    switchMap(parseJsonResponse)
  );
}

export default searchCommunitySitePlansInformation;